import script from "./MysticalExperience.vue?vue&type=script&setup=true&lang=js"
export * from "./MysticalExperience.vue?vue&type=script&setup=true&lang=js"

import "./MysticalExperience.vue?vue&type=style&index=0&id=899d9136&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-899d9136"]])

export default __exports__